import React from 'react';
import { Link } from 'react-router-dom';
import BrowseAllAgent from '../../assets/BrowseAllAgent.png';
const ExploreMarketplacePage = () => {
  const handleMouseOver = (event) => {
    event.target.style.transform = 'translateY(-2px)';
    event.target.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
  };

  const handleMouseOut = (event) => {
    event.target.style.transform = 'translateY(0)';
    event.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
  };

  return (
    <div className="min-h-screen bg-purple-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            Explore the Agent Marketplace
          </h1>

          <div className="text-lg text-gray-800 mb-4">
            The Agent Marketplace is where you can discover prebuilt agents that support students, staff, and faculty across campus.
            <br /><br />
            Each agent has a specific job — answering questions, helping with forms, or automating routine work.
          </div>

          <div className="mb-8">
            <a 
              href="https://app.campusmind.ai/agents-market" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-800 transition-all duration-200 shadow-lg hover:shadow-xl text-lg"
            >
              Explore Marketplace →
            </a>
          </div>
        </div>

        {/* Navigation section */}
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 mb-8 max-w-3xl mx-auto text-center">
          <div className="text-lg md:text-xl font-semibold mb-3">Navigate to Marketplace</div>
          <img
            src="/Marketplace.gif"
            alt="Navigate to Marketplace"
            className="w-full max-w-lg rounded-xl shadow-lg mx-auto mb-4"
          />
        </div>

        {/* Try out a trending agent section */}
        <div className="bg-gray-100 rounded-xl p-6 md:p-8 mb-12 max-w-3xl mx-auto text-center">
          <div className="text-xl md:text-2xl font-bold mb-4 text-gray-800">
            Explore the Agent Marketplace
          </div>

          <div className="text-lg text-gray-700 text-left max-w-lg mx-auto">
            Discover trending agents right from your dashboard—these are the most popular tools being used across campuses today and a great way to see what's making an impact.
            <br /><br />
            {/* <img 
              src="/agent dashboard ss.png" 
              alt="Trending Agents Dashboard Screenshot" 
              className="w-3/4 max-w-xs rounded-xl mx-auto my-4" 
            /> */}
            <br />
            Click on any agent to see how it works and try it out.
            <br /><br />
            <strong>Want to see more?</strong>
            <br />
            Scroll down and click "View All Agents" to open the full marketplace.
            <br />
            <img
              src={BrowseAllAgent}
              alt="View All Agents Screenshot"
              className="w-1/2 max-w-xs rounded-xl mx-auto my-4"
            />
            <br />
            There, you can browse by category, search for specific needs, or get inspired by what others have created.
          </div>
        </div>

        <div className="flex justify-center gap-4 md:gap-8 flex-wrap">
          <Link
            to="/vta-analytics"
            className="bg-gray-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors duration-200"
          >
            Back: Tutor Analytics
          </Link>
          <Link
            to="/"
            className="bg-purple-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-800 transition-colors duration-200"
          >
            Start Over
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExploreMarketplacePage; 
